export default __webpack_public_path__ + "static/media/gift-card 3.e6bab256.svg";